import { __awaiter } from "tslib";
export const listAllPaginatedRecommendedPageSize = 1000;
/**
 * listAllPaginated returns an array of all the values of a specified property from a given paginated List endpoint.
 *
 * Params:
 * - listFunction: a paginated list function
 * - property: the name of the response property to be listed
 * - request: an object with any request filters (or empty)
 */
export const listAllPaginated = (listFunction, property, request) => __awaiter(void 0, void 0, void 0, function* () {
    let acc = [];
    let pageToken = '';
    do {
        const resp = yield listFunction(Object.assign(Object.assign({}, request), { pageToken, nextPageToken: pageToken }));
        // this type assertion is needed because TS can't figure out that respArr is always an array
        const respArr = resp[property];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc = acc.concat(respArr);
        if (isResponsePageToken(resp)) {
            pageToken = resp.pageToken;
        }
        else {
            pageToken = resp.nextPageToken;
        }
    } while (pageToken);
    // this type assertion is to guarantee our return type matches the property type from T
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return acc;
});
function isResponsePageToken(resp) {
    return 'pageToken' in resp;
}
